import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JobseekerSkillItem, JobseekerSkillViewModel, UserTypeEnum } from '@hrra/common-models';

@Component({
    selector: 'hrra-skills',
    templateUrl: './skills.component.html',
    styleUrls: ['./skills.component.scss'],
    standalone: false
})
export class SkillsComponent {

  public type: any;

  @Input() skills: JobseekerSkillViewModel[] | JobseekerSkillItem[];
  @Input() userType: UserTypeEnum;
  @Input() editable = true;
  @Input() removable = false;
  //smaller chips used inside search filter sidebars
  @Input() compact = false;

  @Output() onRemoveSkill: EventEmitter<number> = new EventEmitter<number>();
  @Output() onReorderSkills: EventEmitter<{previousIndex: number, currentIndex: number}> = new EventEmitter<{previousIndex: number, currentIndex: number}>();

  constructor() { this.type = UserTypeEnum }

  public get isEditable(): boolean {
    return this.editable && (this.userType === UserTypeEnum.Jobseeker || this.userType === UserTypeEnum.Internal);
  }

  public onRemove(index: number){
    this.onRemoveSkill.emit(index);
  }

  public onDrop(event: CdkDragDrop<JobseekerSkillViewModel[]>){
    if(event.previousIndex !== event.currentIndex){
      this.onReorderSkills.emit({previousIndex: event.previousIndex, currentIndex: event.currentIndex});
    }
  }
}
